import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { NavItem } from '@core/interfaces';
import { getNavLinkPath } from '@core/utils/routes';

export interface WebTwoNavProps {
  navItems: NavItem[];
  onItemClick?: () => void;
}

const WebTwoNav: React.FC<WebTwoNavProps> = ({ navItems, onItemClick }) => {
  const { pathname } = useLocation();

  return (
    <List dense sx={{ px: 1 }}>
      {navItems.map((item) => {
        const linkPath = getNavLinkPath(item.path);
        const active =
          pathname === linkPath || pathname.startsWith(`${linkPath}/`);
        return (
          <ListItem key={item.path} disablePadding sx={{ mb: 0.5 }}>
            <ListItemButton
              component={Link}
              to={linkPath}
              disabled={item.disabled}
              onClick={onItemClick}
              sx={{
                p: 1,
                borderRadius: 1,
                color: active ? 'text.primary' : 'text.secondary',
                bgcolor: active ? 'action.selected' : 'transparent',
                '&:hover': {
                  bgcolor: active ? 'action.selected' : 'action.hover',
                },
                '&.Mui-disabled': { opacity: 0.5 },
                '&::before': active
                  ? {
                      content: '""',
                      position: 'absolute',
                      left: 0,
                      top: 10,
                      bottom: 10,
                      width: 3,
                      borderRadius: 1,
                      bgcolor: 'primary.main',
                    }
                  : undefined,
              }}
            >
              {item.icon ? (
                <ListItemIcon
                  sx={{
                    color: 'inherit',
                    minWidth: 40,
                    justifyContent: 'center',
                    '& .MuiSvgIcon-root': { fontSize: 22 },
                  }}
                >
                  {item.icon}
                </ListItemIcon>
              ) : null}
              <ListItemText
                primary={item.title}
                primaryTypographyProps={{
                  variant: 'body1',
                  fontWeight: active ? 600 : 500,
                }}
              />
            </ListItemButton>
          </ListItem>
        );
      })}
    </List>
  );
};

export default WebTwoNav;
